import { render } from "./KeyResultIcon.vue?vue&type=template&id=49126bea&scoped=true"
import script from "./KeyResultIcon.vue?vue&type=script&lang=js"
export * from "./KeyResultIcon.vue?vue&type=script&lang=js"

import "./KeyResultIcon.vue?vue&type=style&index=0&id=49126bea&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49126bea"]])

export default __exports__